export default __webpack_public_path__ + "static/media/AboutUs_BG-03.0a74d497.png";